export const PackageType = {
  BASIC: 'BASIC',
  PLUS: 'PLUS',
  EXTRA: 'EXTRA',
  NOT_SELECTED: 'NOT_SELECTED'
}
